"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(ItemType, collection, initial) {
  var idKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'id';
  return initial.withMutations(function (map) {
    collection.reduce(function (acc, item) {
      return acc.set(item[idKey], new ItemType(item));
    }, map);
  });
};

exports.default = _default;
module.exports = exports.default;